import axios, { CreateAxiosDefaults } from "axios";
import config from "config/config";
import { jwt } from "./jwt";

function create(apiHost: string, config?: CreateAxiosDefaults) {
  const { ...rest } = config || {};
  const instance = axios.create({
    baseURL: apiHost,
    timeout: 60000,
    // Cookies are NOT sent by default. Only the auth calls that read/rotate the
    // httpOnly refresh-token cookie (CRM-619) opt in via per-request
    // `withCredentials: true`, so the rest of the API keeps its prior
    // cookie-less behavior.
    ...rest
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
}

export const instance = create(config.apiHost, {});

jwt.attachInterceptors(instance);
